var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 68,
    viewBox: "0 0 71 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1896_3656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30.3159V0.00585938L26.75 15.1609V25.2642L9.25 15.1609V35.3675L0.5 30.3159Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75 15.1609L53 0.00585938V30.3159L35.5 40.4192L26.75 35.3675L44.25 25.2642V15.1609L26.75 25.2642V15.1609Z",
    fill: "#0081CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75 35.3672V45.4705L44.25 55.5739V45.4705L26.75 35.3672Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 55.5742L70.5 40.4192V20.2125L61.75 25.2642V35.3675L44.25 45.4709V55.5742ZM61.75 15.1609V5.05753L70.5 0.00585938V10.1092L61.75 15.1609Z",
    fill: "#0081CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1896_3656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 68,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode13);
export default __webpack_public_path__ + "static/media/code13.74c03c72bef3c5e3ec65776da4c82645.svg";
export { ForwardRef as ReactComponent };